import { render, staticRenderFns } from "./ActionDialog.vue?vue&type=template&id=2d5b5d52&scoped=true"
import script from "./ActionDialog.vue?vue&type=script&lang=js"
export * from "./ActionDialog.vue?vue&type=script&lang=js"
import style0 from "./ActionDialog.vue?vue&type=style&index=0&id=2d5b5d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5b5d52",
  null
  
)

export default component.exports